import { useContext } from "react";
import { useLocation } from "react-router-dom";

import { Header } from "@magnetic/header";
import { Terminal } from "@magnetic/icons";

import { PATHS } from "src/core/constants";
import { DataProviderContext } from "src/core/provider/dataProvider";

import { useManageMockShellModal } from "./manageMockShellHooks";

export const MockShellGlobalHeader = () => {
  const { fabric } = useContext(DataProviderContext);
  const location = useLocation();
  const { openManageMockShellModal, manageMockShellModal } =
    useManageMockShellModal();

  // Only show when fabric exists AND we're on a fabric route
  const isOnFabricRoute = location.pathname.includes(`/${PATHS.FABRIC}/`);
  if (!fabric || !isOnFabricRoute) {
    return null;
  }

  return (
    <>
      <Header.Button
        icon={<Terminal size={22} weight="bold" />}
        label="Quick Command"
        onClick={() => {
          openManageMockShellModal(true);
        }}
      />
      {manageMockShellModal}
    </>
  );
};
